exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".action-col[data-v-618385b6]{float:right;max-width:60px;width:60px}", ""]);

